export const SessionReplay = {
  async enable() {},
};

export enum ImagePrivacyLevel {
  MASK_NON_BUNDLED_ONLY = 'MASK_NON_BUNDLED_ONLY',
  MASK_ALL = 'MASK_ALL',
  MASK_NONE = 'MASK_NONE',
}

export enum TouchPrivacyLevel {
  SHOW = 'SHOW',
  HIDE = 'HIDE',
}

export enum TextAndInputPrivacyLevel {
  MASK_SENSITIVE_INPUTS = 'MASK_SENSITIVE_INPUTS',
  MASK_ALL_INPUTS = 'MASK_ALL_INPUTS',
  MASK_ALL = 'MASK_ALL',
}
